import React, { useContext, useEffect, useState } from "react";
import "../../css_files/Ticket/Step4Ticket.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import getCookie from "../../api";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import { triggerscroll } from "../Homepage/Homepage";

function Step4Ticket({ setCatchStep, setEnquiryId }) {
  setCatchStep(useLocation().pathname.split("/")[4].trim());
  const { quotationId } = useParams();
  const [data, setData] = useState({
    QuotationId: quotationId,
    PaymentDate: null,
    PaymentMethod: "",
    TotalAmountToPay: null,
    AmountPaid: null,
    TransactionId: "",
    IsActive: true,
    ActualQuotationId: 0,
    PaymentMode: "",
  });

  const [orderData, setOrderData] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [dues, setdues] = useState(0);
  const nav = useNavigate();
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [enquiryType, setEnquiryType] = useState("");
  const [loading, setloading] = useState(false);
  const [customerId, setCustomerId] = useState(0);
  const { setExpiredSession, userData, permissionsdata } =
    useContext(triggerscroll);
  const [factoryWorkValue, setFactoryWorkValue] = useState("");
  const [factoryWorkValueDisabled, setFactoryWorkValueDisabled] =
    useState(false);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation/${encodeURIComponent(
          quotationId
        )}`
      )
      .then((res) => {
        setData({
          ...data,
          TotalAmountToPay: Math.round(res?.data?.grandTotal),
          ActualQuotationId: res?.data?.id,
        });
        setCurrencySymbol(res?.data?.symbol);
        setEnquiryType(res?.data?.enquiryType);
        setCustomerId(res?.data?.companyId);
        setEnquiryId(res?.data?.ticket?.enquirySeriesId);
        setFactoryWorkValue(res?.data?.factoryWorkValue);
        if (res.data?.factoryWorkValue) {
          setFactoryWorkValueDisabled(true);
        } else {
          setFactoryWorkValueDisabled(false);
        }
      })
      .catch(console.log);
  }, [quotationId]);

  function handleSubmit(e) {
    e.preventDefault();
    if (parseFloat(data.AmountPaid) > dues) {
      toast.warning("Amount Should Not be Greater than Dues", {
        position: "bottom-center",
        theme: "dark",
      });
      return;
    }
    setloading(true);
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/api/Orders/Add`, data)
      .then((res) => {
        toast.success(res.data, {
          position: "bottom-center",
          theme: "dark",
        });
        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/v1/Quotation/${quotationId}`
          )
          .then((quotationRes) => {
            axiosInstance
              .put(
                `${process.env.REACT_APP_API_URL}/api/v1/Ticket
`,
                {
                  SeriesId: quotationRes.data.ticketId,
                  IsOrderCreated: true,
                }
              )
              .then(() => {
                setrefresh(!refresh);
                setloading(false);
              })
              .catch(console.log);
          })
          .catch((err) => {
            console.log(err);
            setloading(false);
          });

        setData({
          ...data,
          PaymentDate: "",
          PaymentMethod: "",
          AmountPaid: "",
          TransactionId: "",
          PaymentMode: "",
        });
      })
      .catch(console.log);
  }

  useEffect(() => {
    setTotalAmountPaid(0);
    calculateDuesandAmountPaid(
      Number(data.TotalAmountToPay) + Number(factoryWorkValue ?? "0")
    );
  }, [refresh, data, factoryWorkValue]);

  function calculateDuesandAmountPaid(totalAmount) {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Orders/GetOrdersByQuotationId/${data.ActualQuotationId}`
      )
      .then((res) => {
        const orders = res.data.filter((x) => x.isActive === true);
        setOrderData(orders);

        const totalOrderAmount = orders.reduce(
          (acc, order) => acc + parseInt(order.amountPaid || "0"),
          0.0
        );
        const totalPaid = Number(totalOrderAmount);

        setTotalAmountPaid(totalPaid);

        const totalDues = Number(totalAmount) - Number(totalPaid);
        setdues(totalDues);

        updateTicketStatus(
          orders.length > 0,
          totalAmount,
          totalDues,
          orders[0]?.quotation?.symbol
        );
      })
      .catch(console.log);
  }

  function updateTicketStatus(condition, billAmount, dueAmount, symbol) {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation/${encodeURIComponent(
          quotationId
        )}`
      )
      .then(async (res) => {
        await axiosInstance.put(
          `${process.env.REACT_APP_API_URL}/api/v1/Ticket`,
          {
            SeriesId: res.data.ticketId,
            IsOrderCreated: condition,
            BillAmount: billAmount,
            DueAmount: dueAmount,
            Symbol: symbol,
          }
        );
      })
      .catch(console.log);
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Order" && x.isWrite === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Order" && x.isDelete === true
    );
    return !issatisfied;
  }

  function writePermissionInvoice() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Invoice" && x.isWrite === true
    );
    return !issatisfied;
  }

  return (
    <section className="step4-ticket">
      <blockquote>
        <h1>{enquiryType} Order</h1>
        <p>Boiler Service & Commissioning</p>
        <p>
          <strong>Quotation Id: </strong>
          {quotationId}
        </p>
        <h3>
          Quotation Amount: {currencySymbol} {Number(data.TotalAmountToPay)}
        </h3>
        {/*<h3>Factory Work Value: {Number(factoryWorkValue ?? "0")}</h3>*/}
        <h2>
          Amount to Pay: {currencySymbol}{" "}
          {Number(data.TotalAmountToPay) + Number(factoryWorkValue ?? "0")}
        </h2>
      </blockquote>
      {/*<blockquote>
        <label>Factory Work Value</label>
        <input
          type="text"
          value={factoryWorkValue}
          onChange={(e) => {
            const value = e.target.value?.slice(0, 10);
            if (value === "" || /^(?:\d{1,8})(?:\.\d{0,2})?$/.test(value)) {
              axiosInstance
                .put(`${process.env.REACT_APP_API_URL}/api/v1/Quotation`, {
                  SeriesId: quotationId,
                  FactoryWorkValue: value,
                })
                .then((res) => {
                  setrefresh(!refresh);
                })
                .catch(console.log);
              setFactoryWorkValue(value);
            }
          }}
          placeholder="Enter Factory Work Value"
          style={{ padding: "0.5rem", width: "fit-content", fontSize: "1rem" }}
          disabled={factoryWorkValueDisabled}
        />
      </blockquote>*/}

      <form onSubmit={handleSubmit}>
        <h2>Add Payment</h2>
        <div>
          <blockquote>
            <label>Payment Mode</label>
            <blockquote style={{ justifyContent: "left", gap: "1rem" }}>
              <mark>
                <input
                  type="radio"
                  name="PaymentMode"
                  value="Advanced"
                  required
                  onChange={(e) => {
                    setData({ ...data, PaymentMode: e.target.value });
                  }}
                  checked={data.PaymentMode === "Advanced"}
                />
                <span>Advanced</span>
              </mark>
              <mark>
                <input
                  type="radio"
                  name="PaymentMode"
                  value="Credit"
                  required
                  onChange={(e) => {
                    setData({ ...data, PaymentMode: e.target.value });
                  }}
                  checked={data.PaymentMode === "Credit"}
                />
                <span>Credit</span>
              </mark>
            </blockquote>
          </blockquote>
          {data.PaymentMode === "Advanced" && (
            <>
              <blockquote
                style={{
                  gridColumn: "span 2",
                }}
              >
                <label>Payment Method</label>
                <blockquote
                  style={{
                    justifyContent: "left",
                    gap: "1rem",
                  }}
                >
                  <mark>
                    <input
                      type="radio"
                      value="Cash"
                      name="paymentMethod"
                      required
                      onChange={(e) => {
                        if (e.target.checked) {
                          setData({
                            ...data,
                            PaymentMethod: e.target.value,
                            TransactionId: "",
                          });
                        }
                      }}
                      checked={data.PaymentMethod === "Cash"}
                    />
                    <span>Cash</span>
                  </mark>
                  <mark>
                    <input
                      type="radio"
                      value="Credit Card"
                      name="paymentMethod"
                      required
                      onChange={(e) => {
                        if (e.target.checked) {
                          setData({ ...data, PaymentMethod: e.target.value });
                        }
                      }}
                      checked={data.PaymentMethod === "Credit Card"}
                    />
                    <span>Credit Card</span>
                  </mark>
                  <mark>
                    <input
                      type="radio"
                      value="Bank Transfer"
                      name="paymentMethod"
                      required
                      onChange={(e) => {
                        if (e.target.checked) {
                          setData({ ...data, PaymentMethod: e.target.value });
                        }
                      }}
                      checked={data.PaymentMethod === "Bank Transfer"}
                    />
                    <span>Bank Transfer</span>
                  </mark>
                  <mark>
                    <input
                      type="radio"
                      value="Check"
                      name="paymentMethod"
                      required
                      onChange={(e) => {
                        if (e.target.checked) {
                          setData({ ...data, PaymentMethod: e.target.value });
                        }
                      }}
                      checked={data.PaymentMethod === "Check"}
                    />
                    <span>Check</span>
                  </mark>
                  <mark>
                    <input
                      type="radio"
                      value="UPI"
                      name="paymentMethod"
                      required
                      onChange={(e) => {
                        if (e.target.checked) {
                          setData({ ...data, PaymentMethod: e.target.value });
                        }
                      }}
                      checked={data.PaymentMethod === "UPI"}
                    />
                    <span>UPI</span>
                  </mark>
                </blockquote>
              </blockquote>
              <blockquote>
                <label>Payment Date</label>
                <input
                  type="date"
                  required
                  onChange={(e) =>
                    setData({ ...data, PaymentDate: e.target.value })
                  }
                  value={data.PaymentDate}
                />
              </blockquote>

              <blockquote>
                <label>Amount</label>
                <input
                  type="number"
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 10);
                  }}
                  placeholder="Enter Amount"
                  required
                  onChange={(e) =>
                    setData({ ...data, AmountPaid: e.target.value })
                  }
                  value={data.AmountPaid}
                />
              </blockquote>
              {data.PaymentMethod !== "Cash" && (
                <blockquote>
                  <label>Transaction/Reference Id</label>
                  <input
                    type="text"
                    placeholder="Enter Transaction/Reference Id"
                    onChange={(e) =>
                      setData({
                        ...data,
                        TransactionId: e.target.value?.slice(0, 100),
                      })
                    }
                    value={data.TransactionId}
                    required
                  />
                </blockquote>
              )}
            </>
          )}

          <button type={loading ? "button" : "submit"}>
            {loading ? (
              <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
            ) : (
              <p>
                {writePermission()
                  ? "You Do Not Have Permission To Add Orders"
                  : "Add Payment"}
              </p>
            )}
          </button>
        </div>
      </form>
      <main>
        <h2>Payment History</h2>
        <div>
          <table>
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Payment Date</th>
                <th>Amount Paid</th>
                <th>Payment Method</th>
                <th>Payment Mode</th>
                <th>Transaction Id</th>
                <th>Actions</th>
              </tr>
            </thead>
            {orderData && (
              <tbody>
                {orderData.length > 0 ? (
                  orderData.map((order, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{new Date(order.paymentDate).toDateString()}</td>
                      <td>
                        {currencySymbol} {order.amountPaid}
                      </td>
                      <td>{order.paymentMethod}</td>
                      <td>{order.paymentMode}</td>
                      <td>
                        {order.transactionId === ""
                          ? "N/A"
                          : order.transactionId}
                      </td>

                      <td>
                        <i
                          className="fa-solid fa-trash"
                          onClick={() => {
                            Swal.fire({
                              icon: "warning",
                              title: "Are You Sure?",
                              text: "Order Will get Soft Deleted",
                              showConfirmButton: true,
                              showCancelButton: true,
                              confirmButtonText: "Delete",
                            }).then((x) => {
                              if (x.isConfirmed) {
                                axiosInstance
                                  .put(
                                    `${process.env.REACT_APP_API_URL}/api/Orders/DeleteOrder/${order.id}`,
                                    {}
                                  )
                                  .then((res) => {
                                    toast.success(res.data, {
                                      position: "bottom-center",
                                      theme: "dark",
                                    });
                                    setrefresh(!refresh);
                                  })
                                  .catch((err) => {
                                    toast.error("Failed to delete", {
                                      position: "bottom-center",
                                      theme: "dark",
                                    });
                                  });
                              }
                            });
                          }}
                          style={{
                            pointerEvents: deletePermission() && "none",
                            color: deletePermission() && "gray",
                          }}
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6}>
                      <center>
                        <p>No Records Available</p>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
        <h2>
          Total Amount Paid: {currencySymbol} {totalAmountPaid}
        </h2>
        <h2>
          Dues: {currencySymbol} {dues}
        </h2>
      </main>
      <blockquote>
        <button onClick={() => nav(-1)}>Back</button>
        <button
          onClick={() => {
            axiosInstance
              .post(
                `${process.env.REACT_APP_API_URL}/api/Invoice/AddInvoice?EnquiryType=${enquiryType}`,
                {
                  QuotationId: data.ActualQuotationId,
                  PaymentMode: orderData.some((x) => x.paymentMode === "Credit")
                    ? "Credit"
                    : "Advanced",
                }
              )
              .then((res) => {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Invoice Created Successfully",
                }).then(() => {
                  nav(
                    `/dashboard/checkin/steps/step5/${data.ActualQuotationId}`
                  );
                });
              })
              .catch((err) => {
                nav(`/dashboard/checkin/steps/step5/${data.ActualQuotationId}`);
              });
          }}
          disabled={
            !(
              dues === 0 || orderData.some((x) => x.paymentMode === "Credit")
            ) || writePermissionInvoice()
          }
        >
          {writePermissionInvoice()
            ? "You Do Not Have Permission To Create Invoice"
            : "Create (Go To) Invoice"}
        </button>
      </blockquote>
    </section>
  );
}

export default Step4Ticket;
